import React, { useState } from "react";
const Dropdown = React.lazy(() => import('../../ui/dropdown/DropDrown'));
const Input = React.lazy(() => import('../../ui/inputs/input/Input'));
const Label = React.lazy(() => import('../../ui/label/Label'));
const ValidationText = React.lazy(() => import('../../ui/inputs/validation/ValidationText.js'))


const FormInputGroupSelect = ({
    name,
    value,
    dropDownError,
    inputError,
    options,
    onChange,
    dataField,
    labelName,
    placeholder,
    formSetting,
    isMultiSelect,
    onValidation,
    fieldSetting,
    fieldActions,
    ...inputProps
}) => {
    const [selectedFile, setSelectedFile] = useState(null)

    const handleInputChange = (e) => {
        if (onChange) {
            if (e.target.type !== 'file') {
                setSelectedFile(null)
                inputProps?.isEdit ? onChange(dataField[1], e.target.value[1]) : onChange(dataField[1], e.target.value);
            }
        }
    };
    const handleChange = (selectedOption) => {
        if (onChange) {
            if (isMultiSelect) {
                const selectedValues = selectedOption.map((option) => option.value);
                onChange(dataField[0], selectedValues)
            }
            else {
                onChange(dataField[0], selectedOption);
                if (fieldActions) {
                    fieldActions('DDL_CHANGED', dataField[0], selectedOption);
                }
            }
        }
    }

    const handleSelectOnBlur = () => {
        if (onValidation) {
            onValidation(dataField[0]);
        }
    };
    const handleInputOnBlur = () => {

        if (onValidation) {
            onValidation(dataField[1]);
        }
    };

    const validationSalutionFirstNameError =
        (name === 'salutationsID') &&
            (dropDownError !== "" && inputError === "")
            ? "Please enter Salutation"
            : (inputError !== "" && dropDownError === "")
                ? "Please enter Full Name"
                : (inputError !== "" && dropDownError !== "")
                    ? "Please enter Salutation & Full Name" : "";

    return (
        <>
            <div className="input-label-part input-group-select">
                {labelName && labelName !== "" && <Label labelName={labelName} for={name} isRequired={inputProps.isRequired} />}
                {inputProps.hasMainTitle ?
                    <div className="section-title">
                        <h5>{inputProps.hasMainTitle}</h5>
                    </div>
                    : ""}
                <div className="input-group" style={{ flexWrap: "nowrap" }}>
                    <div className="input-group-prepend    ">
                        <Dropdown
                            placeholder={placeholder}
                            onChange={handleChange}
                            onBlur={handleSelectOnBlur}
                            options={options}
                            value={inputProps?.isEdit ? value[0] : value[0]}
                            isMultiSelect={isMultiSelect}
                            isDisable={formSetting?.isViewOnly || inputProps.isDisable}
                            {...inputProps}
                        />
                    </div>
                    {
                        inputProps?.isEdit ?
                            <Input
                                {...inputProps}
                                filename={selectedFile}
                                value={value[1]}
                                onChange={handleInputChange}
                                onBlur={handleInputOnBlur}
                                isDisable={formSetting?.isViewOnly || inputProps?.isDisable || false}
                            />
                            :
                            <Input
                                {...inputProps}
                                filename={selectedFile}
                                value={value[1]}
                                onChange={handleInputChange}
                                onBlur={handleInputOnBlur}
                                isDisable={formSetting?.isViewOnly || inputProps?.isDisable || false}
                            />
                    }

                </div>
            </div>
            <div className="font-normal validation-text mt-1">
                {dropDownError || inputError != " " && <div className="font-normal validation-text mt-1" style={{ color: "red" }}> {`${dropDownError || inputError != " " ? inputError : ""}`} </div>}
            </div>
            {/* {name === 'salutationsID' && <ValidationText error={validationSalutionFirstNameError || ""} />} */}
        </>
    );
};

export default FormInputGroupSelect;
